import ITocItem from "../models/ITocItem";

export const addToTree = (curParent: ITocItem, node: ITocItem) => {
  while (curParent.level >= node.level && curParent.parent) {
    curParent = curParent.parent;
  }
  node.parent = curParent;
  curParent.items.push(node);
  return node;
};

export const removeParents = (node: ITocItem) => {
  const newNode = {
    name: node.name,
    href: node.href,
    level: node.level,
    items: node.items,
    leaf: !node.items.length,
  };
  if (newNode.items) {
    for (let i = 0; i < newNode.items.length; i++) {
      newNode.items[i] = removeParents(newNode.items[i]);
    }
  }
  return newNode;
};

export const removeTrunk = (tree: ITocItem, beforeLevel: number): ITocItem => {
  while (tree.level < beforeLevel && tree.items.length) {
    tree = tree.items[0];
  }
  return tree;
};
